import { QuestionCircleOutlined } from '@ant-design/icons'
import { AuthTo } from '@common/Auth'
import { JUKE_PATH_A, MARKETING_CENTER_PATH } from '@constant'
import { HeaderView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { isStoreAccount } from '@util'
import { Button, Input, Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import { Link } from 'react-router'
import WalletPanel from '../WalletPanel'
import CoverModal from './CoverModal'
import InfoModal from './InfoModal'
import ListModal from './ListModal'
import SideBar from './SideBar'
import store from './store'
import styles from './style.module.less'
import Tabs from './Tabs'

@AuthTo({
  isAuthed: isUltimate,
  link: '/localMerchant/jukeTreasure/intro'
})
@observer
export default class extends Component {
  componentDidMount() {
    store.getWallet()
  }
  render() {
    const {
      valid_code_post,
      visible,
      infoModalVisible,
      listModalVisible,
      coverModalVisible
    } = store
    return (
      <HeaderView
        title={
          <p>
            聚客宝
            <a
              style={{ fontSize: 14, marginLeft: 8 }}
              href={`${JUKE_PATH_A}/rule`}
            >
              聚客宝规则
              <QuestionCircleOutlined
                style={{ color: '#ff8c30', marginLeft: 8, cursor: 'pointer' }}
              />
            </a>
          </p>
        }
        header={
          isStoreAccount()
            ? [<Link to={MARKETING_CENTER_PATH}>营销工具</Link>, '聚客宝']
            : ''
        }
        extra={
          <Fragment>
            <button
              className={`${styles.extraBtn} ${styles.defaultBtn}`}
              onClick={store.showModal}
            >
              活动编码验证
            </button>
            <button
              className={`${styles.extraBtn} ${styles.primaryBtn}`}
              onClick={store.operateModal('infoModalVisible')}
            >
              申请发起活动
            </button>
          </Fragment>
        }
        sideBar={<SideBar />}
      >
        <WalletPanel store={store} />
        <Tabs />
        <Modal
          title="活动编码验证"
          visible={visible}
          onCancel={store.hideModal}
          width={500}
          footer={null}
        >
          <div style={{ padding: '10px 20px' }}>
            <p style={{ color: '#999', fontSize: 14, marginBottom: 20 }}>
              每个报名或中奖的用户都会得到自己的凭证码，您可以扫描用户的二
              维码或在此处输入用户活动编码以确定用户已到场或已兑奖
            </p>
            <Input
              style={{ width: 300, marginRight: 40 }}
              value={valid_code_post}
              onChange={store.changeCode}
            />
            <Button type="primary" onClick={store.checkCode}>
              确 定
            </Button>
          </div>
        </Modal>
        {infoModalVisible && <InfoModal store={store} />}
        {listModalVisible && <ListModal store={store} />}
        {coverModalVisible && <CoverModal store={store} />}
      </HeaderView>
    )
  }
}
